module.exports = __webpack_public_path__ + "static/img/img_d.e2ab9f0f.png";